module.exports = __webpack_public_path__ + "static/media/DMSans-SemiBold.f7dbbac2.woff2";